import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import {  Card, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { Container, CardOrder, MainContainer } from '~/components/layout/Logistic/styles';
import {
  ButtonDivision,
  CardInput,
  CardInputItem,
  CardHeader,
  CloseIconStyled as IconStyled,
  InputQuantity,
  LeftItemQuantity,
  LoadingIcon,
  Product,
  TextQuantity,
  TitlePage as IconsTop,
  Title,
} from './styles';
import '~/components/styles/Global.css';
import close from '~/assets/images/close.png';
import IconProduct from '~/components/layout/IconProduct';
import Stepper from '~/components/layout/Logistic/StepperLine';
import RedirectToInitial from '~/components/layout/Logistic/RedirectToInitial';
import RedirectToPortal from '~/components/layout/Logistic/RedirectToPortal';
import Loading from '~/components/layout/Loading';
import OpenChatBot from '~/components/layout/Chatbot';
import api from '~/services/api';
import back from '~/assets/images/back.svg';
import { verifyRoles } from '~/utils/functions/verifyRoles';
import { InfoButton } from '~/components/layout/Buttons';


export default function SubsidizedContainers() {
  const [loadingPage, setLoadingPage] = useState(true);
  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [financialComposition, setFinancialComposition] = useState(null);
  const [modalRedirect, setModalRedirect] = useState(false);
  const [inputValues, setInputValues] = useState({});
  const [modalCancel, setModalCancel] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();

  const roles = useSelector(state => state.rolesReducer.roles);
  const logisticReducer = useSelector(state => state.logisticReducer);


  useEffect(() => {
    console.log("Logistic reducer subisized --> ", logisticReducer);
    if (logisticReducer?.subsidized?.applied) {
      setInputValues(logisticReducer.subsidized.data);
    }
  }, []);

  useEffect(() => {
    if (logisticReducer.orderDraft.applied) {
      getFinancialReplacement();
    }
  }, []);

  function concatProductsIds(payload) {
    const { products } = payload;
    if (!products || !Array.isArray(products) || products.length === 0) {
      return '';
    }

    const productIds = products.map(product => `&products=${product.productId}`).join('');
    return productIds;
  }

  async function getFinancialReplacement() {
    try {
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem('access_token'),
      };
      const parameters = {
        method: 'GET',
        headers: header,
      };
      const storeId = localStorage.getItem('storeId');
      const url = `/sales/order/v2/orders-ga/${logisticReducer.orderDraft.response.orderId}/replacements?accountId=${storeId}${concatProductsIds(logisticReducer.orderDraft.response)}`;

      const res = await api.get(url, parameters);

      const replacementOptions = res.data;
      const resultReplacement = createReplacementPayload(replacementOptions);
      setFinancialComposition(resultReplacement);

      if (replacementOptions.sponsoreds) {
        const hasSubsidized = replacementOptions?.sponsoreds ? replacementOptions.sponsoreds.find((item) => item.quantity > 0) : null;
        if (hasSubsidized) {
          setLoadingPage(false);
        } else {
          handleToReplacement();
        }
      } else {
        setLoadingConfirm(false);
        handleToReplacement();
      }
    } catch (err) {
      console.log('err => ', err);
      if (err.response) {
        const message = err.response.data.message;
        if (message) {
          toast.error(message);
        } else {
          toast.error('Ocorreu um problema de conexão, pedimos a gentileza de tentar novamente em alguns instantes.');
          setLoadingConfirm(false);
          handleHome();
        }
      }
    }
  };


  function createReplacementPayload(replacementOptions) {
    try {
      const orderProducts = logisticReducer.orderDraft.payload.products || [];

      const replacementList = [];

      const replacementOptionsArray = Object.entries(replacementOptions).map(([type, options]) => {
        return options.map((option) => ({ ...option, type }));
      }).flat();

      for (const product of orderProducts) {
        const productId = parseInt(product.productId);
        const quantity = product.quantity;

        const replacementOption = replacementOptionsArray.filter((option) => parseInt(option.productId) === productId && option.quantity > 0 && option.type === "sponsoreds");

        if (replacementOption.length > 0) {
            const subsidizedEmpties = replacementOption.reduce((acc, item) => {
            if (!acc[item.productId]) {
              acc[item.productId] = 0;
            }
            acc[item.productId] += item.quantity;
            return acc;
          }, {});

          const productName = logisticReducer.products.find((item) => parseInt(item.id) === productId).name;

          replacementList.push({
            productId: productId,
            nameProduct: productName,
            quantity: quantity,
            subsidizedEmpties: subsidizedEmpties[productId.toString()],
            itemsSubsidized: replacementOption,
          });
        }
      }
      const payload = {
        replacement: replacementList,
      };
      return payload;
    } catch (error) {
      console.log("Error in mount payload for componenet:", error);
      return {}
    }
  }


  async function handleInputChange(event, maxValue, productId) {

    const { value } = event.target;
    const valueParsed = parseInt(value ? value : 0);

    if (typeof valueParsed === 'number' && valueParsed >= 0 && valueParsed <= maxValue) {
      setInputValues(prevState => ({
        ...prevState,
        [productId]: {
          ...prevState[productId],
          value: valueParsed,
        }
      }));
    }
  };

  function handleToReplacement() {
    history.push('/composicao-financeira-reposicoes');
  }

  function handleSubsidized() {
    setLoadingConfirm(true);

    const subsidizedData = {
        applied: true,
        data: inputValues
    };

    const isGLP13 = logisticReducer.orderDraft.data.some((item) => item.product.name === 'GLP/P13');

    if (isGLP13) {
        const exceedLimit = logisticReducer.orderDraft.data.some((item) => {
            const productId = Number(item.product.id);
            return inputValues[productId]?.value > item.quantity;
        });

        if (exceedLimit) {
            toast.error('A quantidade de vasilhames subsidiados ultrapassa a quantidade de vasilhames requisitados. Revise seu pedido.');
            setTimeout(() => {
              setLoadingConfirm(false);
            }, 2000);
          } else {
            dispatch({ type: 'SET_SUBSIDIZED', subsidizedData });
            setTimeout(() => {
                setLoadingConfirm(false);
                history.push('/composicao-financeira-reposicoes');
            }, 2000);
        }
    } else {
        dispatch({ type: 'SET_SUBSIDIZED', subsidizedData });
        setTimeout(() => {
            setLoadingConfirm(false);
            history.push('/composicao-financeira-reposicoes');
        }, 2000);
    }
  }


  function handleBack() {
    if (logisticReducer.previousPage === '/criar-pedido') {
      setModalRedirect(true)
    } else {
      history.push(logisticReducer.previousPage);
    }
  }

  function handleHome() {
    history.push('/portal');
  }

  return (
    <Container>
      {verifyRoles(roles, 'PEDIDO_DE_ABASTECIMENTO') ? (
        <>
          <IconsTop>
            <IconStyled
              src={back}
              alt="Ícone de voltar"
              onClick={() => handleBack()}
            />
            <IconStyled
              src={close}
              alt="Ícone de fechar"
              onClick={() => setModalCancel(true)}
            />
          </IconsTop>
          <RedirectToInitial
            modalRedirect={modalRedirect}
            setModalRedirect={setModalRedirect}
          />
          <RedirectToPortal
            modalRedirect={modalCancel}
            setModalRedirect={setModalCancel}
          />
          {loadingPage ? (
            <Loading loadingColor={'white'} />
          ) : (
          <CardOrder>
            <MainContainer>
              <Title>
                <span>Vasilhames Subsidiados</span>
              </Title>
              <Stepper activeStep={3} steps={7} />
              <TextQuantity style={{ marginBottom: '1rem' }}>
                Há vasilhames disponíveis para retirada.
                Selecione abaixo a quantidade que gostaria de incluir nesse pedido.
                (A quantidade total do pedido não se altera).
              </TextQuantity>
              { financialComposition && financialComposition.replacement.map((item) => (
                <>
                  <div key={item.productId} style={{ marginBottom: '1rem' }}>
                    <Card.Header style={CardHeader}>
                      <Product>
                        <IconProduct
                          productName="p13"
                          styles={{
                            p2: { margin: "0 .5rem .2rem 0", width: "15%" },
                            p5: { margin: "0 .5rem .2rem 0", width: "15%" },
                            p20: { margin: "0 .5rem .2rem 0", width: "10%" },
                            p45: { margin: "0 .5rem .2rem 0", width: "10%" },
                            p90: { margin: "0 .5rem .2rem 0", width: "10%" },
                            p13: { margin: "0 .5rem .2rem 0", width: "15%" }
                          }}
                        />
                          <LeftItemQuantity>{ item?.nameProduct ? item.nameProduct : ''  }</LeftItemQuantity>
                      </Product>
                    </Card.Header>
                    <Card style={{ borderTopLeftRadius: '0px', borderTopRightRadius: '0px', boxShadow: '0px 2px 4px #00000033' }}>
                      <CardInput>
                        <CardInputItem>
                          <Row className="flex-nowrap">
                            <Col xs={7}>
                              <TextQuantity style={{ margin: '1rem 0rem 0rem' }}>Quantidade Disponível</TextQuantity>
                            </Col>
                            <Col xs={5} className="align-self-center">
                              <TextQuantity style={{ margin: '1rem 0rem 0rem', textAlign: 'center' }}>{item?.subsidizedEmpties ? item.subsidizedEmpties : 0}</TextQuantity>
                            </Col>
                          </Row>
                        </CardInputItem>
                        <CardInputItem>
                          <Row className="flex-nowrap">
                            <Col xs={7}>
                              <TextQuantity>Quantidade a Retirar</TextQuantity>
                            </Col>
                            <Col xs={5}>
                              <InputQuantity
                                value={inputValues[item.productId]?.value || 0}
                                onChange={(e) => handleInputChange(e, item.subsidizedEmpties, item.productId)}
                                min={0}
                                style={{ color: 'black' }}
                              />
                            </Col>
                          </Row>
                        </CardInputItem>
                      </CardInput>
                    </Card>
                  </div>
                </>
              ))}
              <ButtonDivision onClick={() => handleSubsidized()}>
                <InfoButton style={{ margin: "-1rem 0 1rem 0" }} disabled={loadingConfirm}>
                  {loadingConfirm ? (
                    <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                  ) : (
                    <div>Prosseguir</div>
                  )}
                </InfoButton>
              </ButtonDivision>
            </MainContainer>
            <OpenChatBot backgroundColor={'#00f3ff'} />
          </CardOrder>
          )}
        </>
      ) : (
        <Redirect to="/portal" />
      )}
    </Container>
  );
}
